import React from 'react'

function ErrorPage() {
  return <div>Error 404 page</div>
}

export default ErrorPage
